export default {
    formList: [
        {
            entityField: "start",
            fieldType: "date",
            formatterContent: null,
            isRequired: 0,
            isShow: 1,
            searchId: null,
            extractId: null,
            setField: null,
            showField: "开始时间",
        },
        {
            entityField: "end",
            fieldType: "date",
            formatterContent: null,
            isRequired: 0,
            isShow: 1,
            searchId: null,
            extractId: null,
            setField: null,
            showField: "结束时间",
        },
        
        {
            entityField: "udiType",
            fieldType: "string",
            formatterContent: null,
            isRequired: 0,
            isShow: 1,
            searchId: null,
            extractId: null,
            setField: null,
            showField: "类型",
        },
        {
            entityField: "bgmName",
            fieldType: "string",
            formatterContent: null,
            isRequired: 0,
            isShow: 1,
            searchId: null,
            extractId: null,
            setField: null,
            showField: "通用名称",
        },
        {
            entityField: "batchno",
            fieldType: "string",
            formatterContent: null,
            isRequired: 0,
            isShow: 1,
            searchId: null,
            extractId: null,
            setField: null,
            showField: "批号",
        },
    ],
    tableHeadList: [
        {
            "jctId": 670911,
            "jciId": 1718190824554,
            "entityField": "udiType",
            "chineseField": "数据类型",
            "showField": "数据类型",
            "isShow": 1,
            "fieldType": "string",
            "formatterContent": null,
            "fieldSort": 7,
            "fieldWeight": 130,
            "isRift": 0,
            "riftField": null,
            "isCustomize": null
        },
        {
            "jctId": 670920,
            "jciId": 1718190824554,
            "entityField": "createTime",
            "chineseField": "创建时间",
            "showField": "创建时间",
            "isShow": 1,
            "fieldType": "date",
            "formatterContent": null,
            "fieldSort": 16,
            "fieldWeight": 120,
            "isRift": 0,
            "riftField": null,
            "isCustomize": null
        },
        {
            "jctId": 670912,
            "jciId": 1718190824554,
            "entityField": "bgmName",
            "chineseField": "通用名称",
            "showField": "通用名称",
            "isShow": 1,
            "fieldType": "string",
            "formatterContent": null,
            "fieldSort": 8,
            "fieldWeight": 150,
            "isRift": 0,
            "riftField": null,
            "isCustomize": null
        },
        {
            "jctId": 670913,
            "jciId": 1718190824554,
            "entityField": "spec",
            "chineseField": "规格",
            "showField": "规格",
            "isShow": 1,
            "fieldType": "string",
            "formatterContent": null,
            "fieldSort": 9,
            "fieldWeight": 120,
            "isRift": 0,
            "riftField": null,
            "isCustomize": null
        },
        {
            "jctId": 670914,
            "jciId": 1718190824554,
            "entityField": "manufacturer",
            "chineseField": "生产厂商",
            "showField": "生产厂商",
            "isShow": 1,
            "fieldType": "string",
            "formatterContent": null,
            "fieldSort": 10,
            "fieldWeight": 180,
            "isRift": 0,
            "riftField": null,
            "isCustomize": null
        },
        {
            "jctId": 670915,
            "jciId": 1718190824554,
            "entityField": "bgiRegistno",
            "chineseField": "注册证号",
            "showField": "注册证号",
            "isShow": 1,
            "fieldType": "string",
            "formatterContent": null,
            "fieldSort": 11,
            "fieldWeight": 160,
            "isRift": 0,
            "riftField": null,
            "isCustomize": null
        },
        {
            "jctId": 670916,
            "jciId": 1718190824554,
            "entityField": "batchno",
            "chineseField": "批号",
            "showField": "批号",
            "isShow": 1,
            "fieldType": "string",
            "formatterContent": null,
            "fieldSort": 12,
            "fieldWeight": 120,
            "isRift": 0,
            "riftField": null,
            "isCustomize": null
        },
        {
            "jctId": 670922,
            "jciId": 1718190824554,
            "entityField": "bgpUnitmeasurement",
            "chineseField": "包装单位",
            "showField": "包装单位",
            "isShow": 1,
            "fieldType": "string",
            "formatterContent": null,
            "fieldSort": 18,
            "fieldWeight": 120,
            "isRift": 0,
            "riftField": null,
            "isCustomize": null
        },
        {
            "jctId": 670917,
            "jciId": 1718190824554,
            "entityField": "prodate",
            "chineseField": "生产日期",
            "showField": "生产日期",
            "isShow": 1,
            "fieldType": "string",
            "formatterContent": null,
            "fieldSort": 13,
            "fieldWeight": 160,
            "isRift": 0,
            "riftField": null,
            "isCustomize": null
        },
        {
            "jctId": 670918,
            "jciId": 1718190824554,
            "entityField": "expidate",
            "chineseField": "失效日期",
            "showField": "失效日期",
            "isShow": 1,
            "fieldType": "string",
            "formatterContent": null,
            "fieldSort": 14,
            "fieldWeight": 160,
            "isRift": 0,
            "riftField": null,
            "isCustomize": null
        },
        {
            "jctId": 670919,
            "jciId": 1718190824554,
            "entityField": "businessNum",
            "chineseField": "数量",
            "showField": "数量",
            "isShow": 1,
            "fieldType": "string",
            "formatterContent": null,
            "fieldSort": 15,
            "fieldWeight": 120,
            "isRift": 0,
            "riftField": null,
            "isCustomize": null
        },
       
        {
            "jctId": 670924,
            "jciId": 1718190824554,
            "entityField": "udi",
            "chineseField": "DI码",
            "showField": "DI码",
            "isShow": 1,
            "fieldType": "string",
            "formatterContent": null,
            "fieldSort": 20,
            "fieldWeight": 180,
            "isRift": 0,
            "riftField": null,
            "isCustomize": null
        },
        {
            "jctId": 670925,
            "jciId": 1718190824554,
            "entityField": "udiCode",
            "chineseField": "UDI码",
            "showField": "UDI码",
            "isShow": 1,
            "fieldType": "string",
            "formatterContent": null,
            "fieldSort": 21,
            "fieldWeight": 250,
            "isRift": 0,
            "riftField": null,
            "isCustomize": null
        },
        {
            "jctId": 670923,
            "jciId": 1718190824554,
            "entityField": "xlh",
            "chineseField": "序列号",
            "showField": "序列号",
            "isShow": 1,
            "fieldType": "string",
            "formatterContent": null,
            "fieldSort": 19,
            "fieldWeight": 120,
            "isRift": 0,
            "riftField": null,
            "isCustomize": null
        },
        {
            "jctId": 670905,
            "jciId": 1718190824554,
            "entityField": "businessId",
            "chineseField": "记账单号",
            "showField": "记账单号",
            "isShow": 1,
            "fieldType": "string",
            "formatterContent": null,
            "fieldSort": 1,
            "fieldWeight": 150,
            "isRift": 0,
            "riftField": null,
            "isCustomize": null
        },
        {
            "jctId": 670906,
            "jciId": 1718190824554,
            "entityField": "businessType",
            "chineseField": "业务类型",
            "showField": "业务类型",
            "isShow": 1,
            "fieldType": "string",
            "formatterContent": null,
            "fieldSort": 2,
            "fieldWeight": 100,
            "isRift": 0,
            "riftField": null,
            "isCustomize": null
        },
        {
            "jctId": 670908,
            "jciId": 1718190824554,
            "entityField": "unitName",
            "chineseField": "单位名称",
            "showField": "单位名称",
            "isShow": 1,
            "fieldType": "string",
            "formatterContent": null,
            "fieldSort": 4,
            "fieldWeight": 150,
            "isRift": 0,
            "riftField": null,
            "isCustomize": null
        },
        {
            "jctId": 670909,
            "jciId": 1718190824554,
            "entityField": "socialcode",
            "chineseField": "统一社会信用代码",
            "showField": "统一社会信用代码",
            "isShow": 1,
            "fieldType": "string",
            "formatterContent": null,
            "fieldSort": 5,
            "fieldWeight": 200,
            "isRift": 0,
            "riftField": null,
            "isCustomize": null
        },
        {
            "jctId": 670910,
            "jciId": 1718190824554,
            "entityField": "areaCode",
            "chineseField": "区域码",
            "showField": "区域码",
            "isShow": 1,
            "fieldType": "string",
            "formatterContent": null,
            "fieldSort": 6,
            "fieldWeight": 100,
            "isRift": 0,
            "riftField": null,
            "isCustomize": null
        },
       
       

    ]
}
